import classNames from 'classnames';
import { toast, ToastOptions } from 'react-toastify';
import styled from 'styled-components';
import { Success } from 'components/Icons/Success';

const SuccessToast = styled.div`
  background: white;
  display: flex;
  line-height: 16px;
  border-color: white;
  color: black;
  flex-direction: column;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }

  span {
    word-break: break-word;
  }
`;

const SuccessTitle = styled.div`
  display: flex;
  color: #2e8540;
  font-weight: 600;
  align-items: center;
  margin-bottom: 8px;
  svg {
    margin-right: 8px;
    flex-shrink: 0;
  }
`;

export const showSuccess = (message: string, options: ToastOptions = {}) => {
  if (options.autoClose === false) {
    options.className = classNames(options.className || '', 'toast-with-close');
  }

  return toast.success(
    <SuccessToast>
      <SuccessTitle>
        <Success size={16} fill='#2E8540' /> SUCCESS
      </SuccessTitle>
      {message}
    </SuccessToast>,
    options
  );
};
